// extracted by mini-css-extract-plugin
export default {"message-bar":"index-module__message-bar___JP02Y","messageBar":"index-module__message-bar___JP02Y"};